import React from "react";
import CommiossionDetailsPage from "../../components/Pages/Affiliates/Details/CommissionDetail";

const CommiossionDetails = () => {
  return (
    <div>
      <CommiossionDetailsPage />
    </div>
  );
};

export default CommiossionDetails;
